module.exports = __webpack_public_path__ + "static/media/bq.b93955ad.svg";